import { render, staticRenderFns } from "./devolucionBodega.vue?vue&type=template&id=9f6488e8&scoped=true"
import script from "./devolucionBodega.vue?vue&type=script&lang=js"
export * from "./devolucionBodega.vue?vue&type=script&lang=js"
import style0 from "./devolucionBodega.vue?vue&type=style&index=0&id=9f6488e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6488e8",
  null
  
)

export default component.exports